<template>
    <BModal v-model="isOpen" size="md" centered hide-footer hide-header>
        <OrderLine :lineType="orderLineType" :orderType="orderType"/>
    </BModal>
</template>

<script>
import { mapState } from 'vuex';
import { BModal } from 'bootstrap-vue';
import OrderLine from './OrderLine';

export default {
  props: ['orderType'],
  components: {
    BModal,
    OrderLine,
  },
  computed: {
    isOpen: {
      get() {
        return this.$store.state.orderLines.isModalOpen;
      },
      set(val) {
        this.$store.dispatch('orderLines/clearCurrentOrderLine');
        this.$store.commit('orderLines/isModalOpen', val);
      },
    },
    ...mapState({
      orderLineType: (state) => state.orderLines.orderLineType,
    }),
  },
};
</script>
